define('app/collections/sale_collection',['app/setup','app/models/sale'], function(takhfifan, saleModel) {

  takhfifan.SaleCollection = Backbone.Collection.extend({
    url: '/ajax/product/elements/i/',
    model: takhfifan.Sale,
    comparator: function(item) {
      return [item.get("isSoldOut"), item.get("expired")]
    },
    parse : function(response){
      var deals = [];
      for(var dealId in response){
        response[dealId].id = dealId;
        deals.push(response[dealId]);
      }
      return deals;
    }
  });

});

